import moment from "moment";
import { decryptData } from "../../utils/helper";
import React from 'react';

const ViewMessage = ({ selectedMessage, openImageModal, openPdfModal, setSelectedMessage }) => {
  return (
    <div className="message-container">
      <div className="message-details p-0">
        <button className="back-button" onClick={() => setSelectedMessage(null)}>
          Back
        </button>
        <h2 className="message-subject"><strong>Subject : </strong>{selectedMessage.subject}</h2>
        <div className="message-header">
          <p>
            <strong>From :</strong> {selectedMessage?.senderType !== "Patient" ? selectedMessage?.senderId?.firstName + " "  + selectedMessage?.senderId?.lastName : decryptData(selectedMessage?.senderId?.name[0]?.text)}
          </p>
          {selectedMessage?.to && (selectedMessage.to.firstName || selectedMessage.to.lastName) && (
            <p>
              <strong>To :</strong>{" "}
              {`${selectedMessage.to.firstName || ""} ${selectedMessage.to.lastName || ""}`.trim()}
            </p>
          )}
          {localStorage.getItem("userRole") !== "Platform" &&
            selectedMessage?.patient?.name?.[0]?.text && (
              <p>
                <strong>Patient name :</strong> {decryptData(selectedMessage.patient.name[0].text)}
              </p>
          )}
          <p>
            <strong>Sent At :</strong>{" "}
            {moment(selectedMessage.createdAt).format("MMMM D, YYYY - HH:mm")}
          </p>
        </div>
        <div className="message-content"><strong>Content : </strong> {selectedMessage.content}</div>
        <div className="attachments">
          {selectedMessage?.attachments.map((attachment, index) => {
            const fileType = attachment.key.split(".").pop().toLowerCase();
            if (attachment.publicUrl) {
              if (fileType === "pdf") {
                return (
                  <div key={index} className="attachment-item">
                    <img
                      src="pdf-icon.png"
                      alt="PDF Icon"
                      className="attachment-icon"
                    />
                    <span
                      className="attachment-link"
                      onClick={() => openPdfModal(attachment.publicUrl, attachment.key)}
                    >
                      {attachment.key}
                    </span>
                    <p className="attachment-filename">{attachment.fileName}</p>
                  </div>
                );
              } else if (["png", "jpg", "jpeg"].includes(fileType)) {
                return (
                  <div key={index} className="attachment-item image-item">
                    <img
                      src={attachment.publicUrl}
                      alt={`attachment-${index}`}
                      className="attachment-thumbnail"
                      onClick={() => openImageModal(attachment.publicUrl)}
                    />
                    <p className="attachment-filename">{attachment.fileName}</p>
                  </div>
                );
              } else {
                return (
                  <div key={index} className="attachment-item">
                    <a
                      href={attachment.publicUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="attachment-link"
                    >
                      {attachment.key}
                    </a>
                    <p className="attachment-filename">{attachment.fileName}</p>
                  </div>
                );
              }
            } else {
              return (
                <div key={index} className="attachment-item">
                  <h3>Attachment not available</h3>
                  <p>Sorry, the attachment could not be fetched.</p>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default ViewMessage;
